// Client-side season pass helpers.
//
// Quest tracking is fully server-authoritative. The server attaches the
// per-season `activeQuests` slate (template + per-player progress +
// completed flag) to /me/season responses, and applies progress
// transactionally inside the endpoints that fire each event
// (match claim, pack open, auction sale). The client just renders.
//
// What lives here is the legacy XP / tier helpers that some non-network
// code paths still call (e.g. previewing a tier badge). The actual
// numbers come from /me/season; these functions are pure.

export function getSeasonLevel(seasonXp, tiers) {
  let level = 0;
  for (const tier of tiers || []) {
    if (seasonXp >= tier.xpRequired) level = tier.level;
    else break;
  }
  return level;
}

export function getNextTierInfo(seasonXp, tiers) {
  for (const tier of tiers || []) {
    if (seasonXp < tier.xpRequired) {
      return {
        level: tier.level,
        xpRequired: tier.xpRequired,
        xpRemaining: tier.xpRequired - seasonXp,
        reward: tier.reward,
      };
    }
  }
  return null;
}

export function canClaimTier(level, seasonXp, claimedTiers, tiers) {
  const tier = (tiers || []).find((t) => t.level === level);
  if (!tier) return false;
  return seasonXp >= tier.xpRequired && !(claimedTiers || []).includes(level);
}

export function getTimeRemaining(endsAt) {
  const ms = new Date(endsAt).getTime() - Date.now();
  if (ms <= 0) return { days: 0, hours: 0, expired: true };
  const days = Math.floor(ms / (24 * 60 * 60 * 1000));
  const hours = Math.floor((ms % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000));
  return { days, hours, expired: false };
}

// Default empty progress. Used as a render-time fallback before /me/season
// responds; the server is the source of truth once the request lands.
export function createDefaultSeasonProgress(seasonId) {
  return {
    seasonId,
    seasonXp: 0,
    claimedTiers: [],
    questProgress: {},
    completedQuestIds: [],
    questState: { winStreak: 0, avatarsWonWith: [] },
  };
}

